import { queryOptions, skipToken, useQuery } from "@tanstack/react-query";
import api from "../../../../api";
import urls from "../../../../urls";
import type { MeteringServiceProvider } from "../../../../utils/backend-types";

export const meteringServiceProviderQueries = {
  all: () =>
    queryOptions({
      queryKey: ["metering-service-provider"],
      queryFn: fetchMeteringServiceProviders
    }),
  detail: (mspId: number | null) =>
    queryOptions({
      queryKey: ["metering-service-providers", { mspId }],
      queryFn: mspId ? () => fetchMeteringServiceProvider(mspId) : skipToken
    })
};

export function useMeteringServiceProviders() {
  return useQuery(meteringServiceProviderQueries.all());
}

export function useMeteringServiceProvider(mspId: number | null = null) {
  return useQuery(meteringServiceProviderQueries.detail(mspId));
}

async function fetchMeteringServiceProviders() {
  const { data } = await api.get<Array<MeteringServiceProvider>>(
    urls.api.meteringServiceProviders()
  );
  return data;
}

async function fetchMeteringServiceProvider(mspId: number) {
  const { data } = await api.get<MeteringServiceProvider>(
    urls.api.meteringServiceProvider(mspId)
  );
  return data;
}
